/** Authoritative main variant for ATC — URL wins over stale hidden inputs. */
function getSelectedMainVariantId() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return String(fromUrl);
  } catch (_) {}

  const info = document.querySelector('ee-configurator-product-info');
  if (info?.currentVariant?.id) return String(info.currentVariant.id);

  const form = document.querySelector('ee-product-form form');
  if (!form) return null;

  const items0 = form.querySelector('input[name="items[0][id]"]');
  if (items0?.value) return String(items0.value);

  const main = form.querySelector('input[name="id"]');
  if (main?.value) return String(main.value);

  return null;
}

function syncMainVariantInputs(form, variantId) {
  if (!form || variantId == null || variantId === '') return;
  const id = String(variantId);
  const mainInput = form.querySelector('input[name="id"]');
  if (mainInput) mainInput.value = id;
  const itemsMain = form.querySelector('input[name="items[0][id]"]');
  if (itemsMain) itemsMain.value = id;
}

window.EeConfiguratorVariantSync = {
  getSelectedMainVariantId,
  syncMainVariantInputs,
};

function getConfiguratorFreeGiftIds() {
  return Array.from(
    document.querySelectorAll('.free-gift-wrapper input[disabled][data-add-on-id]')
  )
    .map((input) => input.getAttribute('data-add-on-id'))
    .filter(Boolean);
}

function getMetaobjectDataFromDom(form) {
  const root = form.closest('ee-configurator-product-info') || document;
  const metaobjectData = {};
  const combinedInputs = root.querySelectorAll('[data-combined-prod-id]');
  root.querySelectorAll('[data-metaobject-ids]').forEach((el, i) => {
    const metaobjectIds = (el.getAttribute('data-metaobject-ids') || el.value || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    const combinedEl =
      (el.nextElementSibling?.hasAttribute?.('data-combined-prod-id') && el.nextElementSibling) ||
      combinedInputs[i];
    const combinedProdId = (
      combinedEl?.getAttribute('data-combined-prod-id') ||
      combinedEl?.value ||
      ''
    )
      .replace(/[\[\]\s]/g, '')
      .trim();
    metaobjectData[`metaobject_${i + 1}`] = { metaobjectIds, combinedProdId };
  });
  return metaobjectData;
}

function collectCartItemIdsFromForm(form) {
  const ids = [];
  const mainId = getSelectedMainVariantId();
  if (mainId) {
    syncMainVariantInputs(form, mainId);
    ids.push(String(mainId));
  }

  form.querySelectorAll('input[name^="items["][name$="[id]"]').forEach((input) => {
    if (input.name === 'items[0][id]') return;
    if (input.disabled || !input.value) return;
    ids.push(String(input.value));
  });

  return ids;
}

function applyProductCombination(form) {
  const metaobjectData = getMetaobjectDataFromDom(form);
  if (!Object.keys(metaobjectData).length) return;

  const selectedIds = collectCartItemIdsFromForm(form);
  if (!selectedIds.length) return;

  let bestMatch = {
    combinedProdId: null,
    matchedIds: [],
    matchCount: 0,
    isComplete: false,
  };

  Object.values(metaobjectData).forEach((entry) => {
    const metaobjectIds = entry.metaobjectIds || [];
    const matchedIds = metaobjectIds.filter((id) => selectedIds.includes(String(id)));
    const isCompleteMatch =
      metaobjectIds.length === matchedIds.length &&
      metaobjectIds.length === selectedIds.length;

    if (isCompleteMatch) {
      bestMatch = {
        combinedProdId: entry.combinedProdId,
        matchedIds,
        matchCount: matchedIds.length,
        isComplete: true,
      };
      return;
    }

    const isPartialMatch = metaobjectIds.length === matchedIds.length;
    if (isPartialMatch && matchedIds.length > bestMatch.matchCount) {
      bestMatch = {
        combinedProdId: entry.combinedProdId,
        matchedIds,
        matchCount: matchedIds.length,
        isComplete: false,
      };
    }
  });

  if (!bestMatch.combinedProdId) return;

  form
    .querySelectorAll('.addon-variant-input, .addon-quantity-input, .free-gift-variant-input, .free-gift-quantity-input')
    .forEach((input) => input.remove());

  const mainVariantInput = form.querySelector('input[name="id"]');
  if (mainVariantInput) {
    mainVariantInput.disabled = false;
    mainVariantInput.style.display = '';
  }

  form.querySelectorAll('input[name^="items["]').forEach((input) => input.remove());

  const combinedId = String(bestMatch.combinedProdId).replace(/[\[\]]/g, '').trim();
  if (!combinedId) return;

  if (bestMatch.isComplete) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'items[0][id]';
    hidden.value = combinedId;
    hidden.className = 'product-variant-id';
    form.appendChild(hidden);

    const qty = document.createElement('input');
    qty.type = 'hidden';
    qty.name = 'items[0][quantity]';
    qty.value = form.querySelector('input[name="quantity"]')?.value || '1';
    form.appendChild(qty);

    if (mainVariantInput) {
      mainVariantInput.disabled = true;
    }
    return;
  }

  const remainingIds = selectedIds.filter(
    (id) => !bestMatch.matchedIds.includes(String(id))
  );

  let index = 0;
  const combinedInput = document.createElement('input');
  combinedInput.type = 'hidden';
  combinedInput.name = `items[${index}][id]`;
  combinedInput.value = combinedId;
  combinedInput.className = 'product-variant-id';
  form.appendChild(combinedInput);

  const combinedQty = document.createElement('input');
  combinedQty.type = 'hidden';
  combinedQty.name = `items[${index}][quantity]`;
  combinedQty.value = '1';
  form.appendChild(combinedQty);
  index += 1;

  remainingIds.forEach((id) => {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = `items[${index}][id]`;
    hidden.value = id;
    hidden.className = 'addon-variant-input';
    form.appendChild(hidden);

    const qty = document.createElement('input');
    qty.type = 'hidden';
    qty.name = `items[${index}][quantity]`;
    qty.value = '1';
    qty.className = 'addon-quantity-input';
    form.appendChild(qty);
    index += 1;
  });

  if (mainVariantInput) {
    mainVariantInput.disabled = true;
  }
}

function ensureCompulsoryAddOnInForm() {
  const compulsoryId = window.eeConfiguratorCompulsory?.currentCompulsoryAddOn;
  if (!compulsoryId) return;

  const input = document.querySelector(
    `configurator-add-ons input[data-add-on-id="${compulsoryId}"]`
  );
  if (!input) return;

  const component = document.querySelector('configurator-add-ons');
  if (!component?.updateFormWithAddOns) return;

  const variantId =
    input.getAttribute('data-variant-id') || input.getAttribute('data-add-on-id');
  if (!variantId) return;

  if (!input.checked) input.checked = true;
  component.selectedAddOns.set(String(variantId), {
    productId: input.dataset.productId || input.value,
    variantId: String(variantId),
    input,
  });
  component.updateFormWithAddOns();
}

function appendConfiguratorFreeGifts(form) {
  const giftIds = getConfiguratorFreeGiftIds();
  if (!giftIds.length) return;

  form
    .querySelectorAll('.free-gift-variant-input, .free-gift-quantity-input')
    .forEach((input) => input.remove());

  const existingIds = new Set(
    Array.from(form.querySelectorAll('input[name="id"], input[name^="items["][name$="[id]"]'))
      .filter((input) => !input.disabled && input.value)
      .map((input) => input.value)
  );

  let mainVariantInput = form.querySelector('input[name="id"]');
  let itemsMainInput = form.querySelector('input[name="items[0][id]"]');

  if (!itemsMainInput && mainVariantInput?.value) {
    itemsMainInput = document.createElement('input');
    itemsMainInput.type = 'hidden';
    itemsMainInput.name = 'items[0][id]';
    itemsMainInput.className = 'product-variant-id';
    itemsMainInput.value = mainVariantInput.value;
    form.appendChild(itemsMainInput);

    let itemsQuantityInput = form.querySelector('input[name="items[0][quantity]"]');
    if (!itemsQuantityInput) {
      itemsQuantityInput = document.createElement('input');
      itemsQuantityInput.type = 'hidden';
      itemsQuantityInput.name = 'items[0][quantity]';
      itemsQuantityInput.value =
        form.querySelector('input[name="quantity"]')?.value || '1';
      form.appendChild(itemsQuantityInput);
    }

    mainVariantInput.disabled = true;
  }

  let nextIndex = 0;
  form.querySelectorAll('input[name^="items["][name$="[id]"]').forEach((input) => {
    const match = input.name.match(/items\[(\d+)\]\[id\]/);
    if (match) nextIndex = Math.max(nextIndex, parseInt(match[1], 10) + 1);
  });

  giftIds.forEach((giftId) => {
    if (existingIds.has(giftId)) return;

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = `items[${nextIndex}][id]`;
    hiddenInput.value = giftId;
    hiddenInput.className = 'free-gift-variant-input';
    form.appendChild(hiddenInput);

    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = `items[${nextIndex}][quantity]`;
    quantityInput.value = '1';
    quantityInput.className = 'free-gift-quantity-input';
    form.appendChild(quantityInput);

    existingIds.add(giftId);
    nextIndex += 1;
  });
}

if (!customElements.get('ee-product-form')) {
  customElements.define(
    'ee-product-form',
    class EEProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this._boundSubmit = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this._boundSubmit);

        this._onVariantChanged = (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId && this.form) {
            syncMainVariantInputs(this.form, variantId);
          }
        };
        document.addEventListener('configurator:variant-changed', this._onVariantChanged);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      disconnectedCallback() {
        if (this.form && this._boundSubmit) {
          this.form.removeEventListener('submit', this._boundSubmit);
        }
        if (this._onVariantChanged) {
          document.removeEventListener('configurator:variant-changed', this._onVariantChanged);
        }
      }

      setLoadingSpinnerVisible(visible) {
        const button = this.submitButton || this.querySelector('[type="submit"]');
        if (!button) return;

        const dawnSpinner = button.querySelector('.loading__spinner');
        const legacySpinner = button.querySelector('.loading-overlay__spinner');

        if (dawnSpinner) {
          dawnSpinner.classList.toggle('hidden', !visible);
          dawnSpinner.classList.toggle('d-none', !visible);
        }
        if (legacySpinner) {
          legacySpinner.classList.toggle('hidden', !visible);
          legacySpinner.classList.toggle('d-none', !visible);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        if (!this.submitButton) return;
        if (this.submitButton.classList.contains('loading')) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading');
        this.setLoadingSpinnerVisible(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const mainVariantId = getSelectedMainVariantId();
        if (mainVariantId) syncMainVariantInputs(this.form, mainVariantId);

        const addOns = document.querySelector('configurator-add-ons');
        if (addOns?.selectedAddOns?.size > 0 && addOns.updateFormWithAddOns) {
          addOns.updateFormWithAddOns();
        }

        ensureCompulsoryAddOnInForm();
        applyProductCombination(this.form);
        appendConfiguratorFreeGifts(this.form);

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            this.error = false;
          })
          .catch(() => {
            this.error = true;
          })
          .finally(() => {
            if (!this.error) {
              window.location.href = window.routes.cart_url;
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-busy');
              this.setLoadingSpinnerVisible(false);
              return;
            }

            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
            this.setLoadingSpinnerVisible(false);

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButton = this.submitButton || this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButtonText || this.submitButton?.querySelector('span');
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"], [name="items[0][id]"]');
      }

      normalizeCartAddResponse(response, formData) {
        if (response.key) return response;

        const mainVariantId = formData.get('items[0][id]') || formData.get('id');
        const items = response.items;

        if (Array.isArray(items) && items.length) {
          const mainItem = mainVariantId
            ? items.find((item) => String(item.id) === String(mainVariantId))
            : null;
          response.key = (mainItem || items[items.length - 1] || items[0]).key;
        }

        return response;
      }
    }
  );
}
